import { lazy } from "react"
import { RouteObject } from "react-router"

const Rate = lazy(() => import("@/pkg_banner/rate/index"))
const Collection = lazy(() => import("@/pkg_banner/collection/index"))

const actRouter: RouteObject[] = [
  {
    path: "/rate",
    element: <Rate />,
  },
  {
    path: "collection",
    element: <Collection />,
  },
]

export default actRouter
